<ng-container *ngIf="viewModel$ | async as viewModel">
  <ng-container *ngIf="viewModel.eventOfferTypes.length > 0">
    <div class="list-header" fxLayout="row" fxLayoutAlign="end center">
      <a class="view-selected-link" *ngIf="canEdit() && selectedCount > 0" appAuthorizeControl="edit||offermang" href="#"
        matTooltip="Selected Records" (click)="onViewSelected($event)">
        View selected ({{ selectedCount }})
      </a>
    </div>

    <table mat-table [dataSource]="tableVariantDataSource" [trackBy]="trackDisplayRow" matSort (matSortChange)="onSort($event)"
      matSortDisableClear [matSortStart]="'desc'">

      <!-- Checkbox Column -->
      <ng-container matColumnDef="select">
        <th class="no-ellipsis" mat-header-cell *matHeaderCellDef>
          <mat-checkbox (change)="toggleSelectAll($event.checked)" [checked]="isAllSelected()"
            [indeterminate]="isSomeSelectedOnPage() && !isAllSelected()"></mat-checkbox>
        </th>
        <td class="no-ellipsis" mat-cell *matCellDef="let record">
          <mat-checkbox *ngIf="record.kind === 'base'" (click)="$event.stopPropagation()"
            (change)="toggleSelect($event.checked, record.offer)" [checked]="selection.isSelected(record.offer)">
          </mat-checkbox>
        </td>
      </ng-container>

      <!--  Image Column -->
      <ng-container matColumnDef="Image">
        <th mat-header-cell *matHeaderCellDef [resizeColumn]="true">Preview</th>
        <td mat-cell *matCellDef="let record">
          <ng-container *ngIf="record.kind === 'skeleton'">
            <mat-progress-bar class="table-variant-skeleton-bar" mode="indeterminate" color="accent"></mat-progress-bar>
          </ng-container>
          <ng-container *ngIf="record.kind !== 'skeleton'">
            <img mat-card-md-image
              [src]="record.offer?.FacingAsset ? (record.offer?.FacingAsset | offerPreview: PreviewMode.Thumbnail) : './assets/images/default-image.png'"
              alt="Offer image" (error)="onImageError($event)">
          </ng-container>
        </td>
      </ng-container>

      <!-- OfferName Column -->
      <ng-container matColumnDef="Name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Name"
          [resizeColumn]="true">
          Name</th>
        <td mat-cell *matCellDef="let record">
          <ng-container *ngIf="record.kind === 'skeleton'">
            <span class="table-skeleton-label">Loading variant…</span>
          </ng-container>
          <ng-container *ngIf="record.kind !== 'skeleton'">{{ record.offer?.Detail?.Name }}</ng-container>
        </td>
      </ng-container>

      <!-- Headline Column -->
      <ng-container matColumnDef="Headline">
        <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Headline"
          [resizeColumn]="true">Headline</th>
        <td mat-cell *matCellDef="let record">
          <ng-container *ngIf="record.kind === 'skeleton'">—</ng-container>
          <ng-container *ngIf="record.kind !== 'skeleton'">{{ record.offer?.Detail?.Headline }}</ng-container>
        </td>
      </ng-container>

      <!-- BodyCopy Column -->
      <ng-container matColumnDef="BodyCopy">
        <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by BodyCopy"
          [resizeColumn]="true">Body Copy</th>
        <td mat-cell *matCellDef="let record">
          <ng-container *ngIf="record.kind === 'skeleton'">—</ng-container>
          <ng-container *ngIf="record.kind !== 'skeleton'">{{ record.offer?.Detail?.BodyCopy }}</ng-container>
        </td>
      </ng-container>

      <!-- EventType Column -->
      <ng-container matColumnDef="EventType">
        <th mat-header-cell *matHeaderCellDef [resizeColumn]="true">Type</th>
        <td mat-cell *matCellDef="let record">
          <ng-container *ngIf="record.kind === 'skeleton'">—</ng-container>
          <ng-container *ngIf="record.kind !== 'skeleton'">{{ record.offer?.EventOfferType == 'OFFERGROUP'? 'OFFER GROUP':record.offer?.EventOfferType }}
            <span *ngIf="record.offer?.EventOfferType == 'OFFERGROUP'">({{record.offer?.OffersCount}})</span>
          </ng-container>
        </td>
      </ng-container>

      <!-- Status Column -->
      <ng-container matColumnDef="Status">
        <th class="w-120" mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Status"
          [resizeColumn]="true">Status</th>
        <td mat-cell *matCellDef="let record">
          <ng-container *ngIf="record.kind === 'skeleton'">—</ng-container>
          <ng-container *ngIf="record.kind !== 'skeleton'">
            <div class="offer-status column-status">
              <span [matMenuTriggerFor]="canEdit() ? menu : null" class="ellipsis-3-line {{ getStatusClass(record.offer) }}">
                {{ getStatusText(record.offer) }}
                <mat-icon *ngIf="canEdit()" class="icon">arrow_drop_down</mat-icon>
              </span>
            </div>

            <mat-menu #menu="matMenu" class="status-menu">
              <button type="button" mat-menu-item class="statusAPPROVED"
                [disabled]="record.offer?.Detail?.Status === 'APPROVED'"
                (click)="updateStatus(Status.APPROVED, record.offer)">APPROVED
              </button>
              <button type="button" mat-menu-item class="statusPENDING" [disabled]="record.offer?.Detail?.Status === 'PENDING'"
                (click)="updateStatus(Status.PENDING, record.offer)">PENDING
              </button>
              <button type="button" mat-menu-item class="statusSUPPRESSED"
                [disabled]="record.offer?.Detail?.Status === 'SUPPRESSED'"
                (click)="updateStatus(Status.SUPPRESSED, record.offer)">SUPPRESSED
              </button>
            </mat-menu>
          </ng-container>
        </td>
      </ng-container>

      <!-- Version Column -->
      <ng-container matColumnDef="Version">
        <th mat-header-cell *matHeaderCellDef [resizeColumn]="true">Variant</th>
        <td mat-cell *matCellDef="let record; let i = index;">
          <ng-container *ngIf="record.kind === 'skeleton'">—</ng-container>
          <ng-container *ngIf="record.kind === 'variant' && record.offer?.Detail?.OfferVariantName">
            <span class="table-variant-name-chip">{{ record.offer?.Detail?.OfferVariantName }}</span>
          </ng-container>
          <mat-form-field class="versions" appearance="outline"
            *ngIf="variantViewMode === 'compressed' && record.kind === 'base' && record.offer?.Variants?.length > 1">
            <mat-select [(value)]="record.offer.Detail.Id" placeholder="Select Variant"
              (selectionChange)="onVariantChange($event.value, record.offer)">
              <mat-option *ngFor="let variant of record.offer?.Variants" [value]="variant?.Id">
                {{variant?.OfferVariantName}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </td>
      </ng-container>

      <!-- Rank Column -->
      <ng-container matColumnDef="Rank">
        <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Rank"
          [resizeColumn]="true">
          Rank</th>
        <td mat-cell *matCellDef="let record">
          <ng-container *ngIf="record.kind === 'skeleton'">—</ng-container>
          <ng-container *ngIf="record.kind !== 'skeleton'">{{ record.offer?.Detail?.Rank }}</ng-container>
        </td>
      </ng-container>

      <!-- Comments Column -->
      <ng-container matColumnDef="Comments">
        <th mat-header-cell *matHeaderCellDef [resizeColumn]="true">Comments</th>
        <td mat-cell *matCellDef="let record;let i = index">
          <ng-container *ngIf="record.kind === 'skeleton'">—</ng-container>
          <ng-container *ngIf="record.kind !== 'skeleton'">
            <ng-container *ngIf="record.offer?.CommentsCount !== undefined && record.offer?.CommentsCount! > 0; else noComments">
              <div id="{{record?.offer.DomainId}}" (click)="openDialog($event, record.offer)" class="comments-dialog font-18">
                <i class="fa fa-comment font-12" aria-hidden="true"></i>
                <span class="comments-count">{{record.offer?.CommentsCount}}</span>
              </div>
            </ng-container>
            <ng-template #noComments>
              <span id="{{record?.offer.DomainId}}" (click)="openDialog($event, record.offer)" class="comments-dialog font-18">
                <i class="fa fa-comment-o font-12" aria-hidden="true"></i>
              </span>
            </ng-template>
          </ng-container>
        </td>
      </ng-container>

      <!-- Tags Column -->
      <ng-container matColumnDef="Tags">
        <th mat-header-cell *matHeaderCellDef [resizeColumn]="true">Tags</th>
        <td title="{{ record.offer?.OfferTagNames }}" mat-cell *matCellDef="let record">
          <ng-container *ngIf="record.kind === 'skeleton'">—</ng-container>
          <ng-container *ngIf="record.kind !== 'skeleton'">{{record.offer?.OfferTagNames }}</ng-container>
        </td>
      </ng-container>

      <!-- VersionCodes Column -->
      <ng-container matColumnDef="VersionCodes">
        <th mat-header-cell *matHeaderCellDef [resizeColumn]="true">Versions</th>
        <td title="{{ record.offer?.VersionNames }}" mat-cell *matCellDef="let record">
          <ng-container *ngIf="record.kind === 'skeleton'">—</ng-container>
          <ng-container *ngIf="record.kind !== 'skeleton'">{{record.offer?.VersionNames }}</ng-container>
        </td>
      </ng-container>

      <!-- Versions Column -->
      <ng-container matColumnDef="Versions">
        <th mat-header-cell *matHeaderCellDef [resizeColumn]="true">Variants</th>
        <td mat-cell *matCellDef="let record">
          <ng-container *ngIf="record.kind === 'skeleton'"></ng-container>
          <ng-container *ngIf="record.kind === 'variant'"></ng-container>
          <ng-container *ngIf="record.kind === 'base'">
            <button *ngIf="record.offer?.VariantsCount && record.offer?.VariantsCount > 1 && record.offer?.EventOfferType === 'OFFER'"
              mat-button type="button" color="accent" [routerLink]="[record.offer?.Detail?.Id, 'childversions']">
              Variants({{record.offer?.VariantsCount}})</button>
            <button *ngIf="record.offer?.VariantsCount && record.offer?.VariantsCount > 1 && record.offer?.EventOfferType === 'PROMO'"
              mat-button type="button" color="accent" [routerLink]="[record.offer?.Detail?.Id, 'promo', 'childversions']">
              Variants({{record.offer?.VariantsCount}})</button>
          </ng-container>
        </td>
      </ng-container>

      <!-- PageNumber Column -->
      <ng-container matColumnDef="PageNumber">
        <th mat-header-cell *matHeaderCellDef [resizeColumn]="true">Page</th>
        <td title="{{ record.offer?.PageNumber }}" mat-cell *matCellDef="let record" class="text-center">
          <ng-container *ngIf="record.kind === 'skeleton'">—</ng-container>
          <ng-container *ngIf="record.kind !== 'skeleton'">{{record.offer?.PageNumber }}</ng-container>
        </td>
      </ng-container>

      <!-- Position Column -->
      <ng-container matColumnDef="Position">
        <th mat-header-cell *matHeaderCellDef [resizeColumn]="true">Position</th>
        <td title="{{ record.offer?.Position }}" mat-cell *matCellDef="let record" class="text-center">
          <ng-container *ngIf="record.kind === 'skeleton'">—</ng-container>
          <ng-container *ngIf="record.kind !== 'skeleton'">{{record.offer?.Position }}</ng-container>
        </td>
      </ng-container>

      <!-- Actions Column -->
      <ng-container matColumnDef="Actions">
        <th mat-header-cell *matHeaderCellDef class="pl-20">Actions</th>
        <td mat-cell *matCellDef="let record">
          <ng-container *ngIf="record.kind === 'skeleton'">—</ng-container>
          <ng-container *ngIf="record.kind !== 'skeleton'">
            <button *ngIf="record.offer?.EventOfferType === 'OFFER'" class="offer-button" type="button" mat-button
              color="accent" [routerLink]="[record.offer?.Detail?.Id, 'details']" [queryParamsHandling]="'preserve'">
              <span>{{canEdit()?'Edit':'View Details'}}</span>
            </button>
            <button *ngIf="record.offer?.EventOfferType === 'PROMO'" class="offer-button" type="button" mat-button
              color="accent" [routerLink]="[record.offer?.Detail?.Id, 'promos', 'promodetails']"
              [queryParamsHandling]="'preserve'">
              <span>{{canEdit()?'Edit':'View Details'}}</span>
            </button>
            <button *ngIf="record.offer?.EventOfferType === 'OFFERGROUP'" class="offer-button" type="button" mat-button
              color="accent" [routerLink]="[record.offer?.Detail?.Id, 'offergroups', 'offergrpdetails']"
              [queryParamsHandling]="'preserve'">
              <span>{{canEdit()?'Edit':'View Details'}}</span>
            </button>
          </ng-container>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"
        [ngClass]="{ 'mat-row-variant': row.kind === 'variant', 'mat-row-skeleton': row.kind === 'skeleton' }"></tr>
    </table>
  </ng-container>

  <ng-container *ngIf="viewModel?.eventOfferTypes?.length === 0">
    <table>
      <tr>
        <td class="no-records" >
          <h2>No offers Found</h2>
        </td>
      </tr>
    </table>
  </ng-container>
</ng-container>
